/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

const getLastRegistre = (typeRegistre: number) =>
  `${baseUrlApi}/registres/last/${typeRegistre}`;
const getListeRegistres = (search?: string, typeRegistre?: number | null) => {
  const url = `${baseUrlApi}/registres/liste?typeRegistre=${typeRegistre ?? '10,11'}`;
  return search ? `${url}&search=${encodeURIComponent(search)}` : url;
};
/**
 * Dernier numéro de PACS enregistré sur un registre (année + numéro + type).
 */
const getNumeroLastPacs = (
  anneeRegistre: number | string,
  numeroRegistre: number | string,
  typeRegistre: number | string,
) =>
  `${baseUrlApi}/registres/numero-last-pacs/${anneeRegistre}/${numeroRegistre}/${typeRegistre}`;

export { getLastRegistre, getListeRegistres, getNumeroLastPacs };
